<template>
  <popup
    :value="value"

    @input="$emit('input', $event)"
    title="Добро пожаловать в приёмную комиссию Университета Синергия!"
  >
    <template v-slot:content>
      <vuescroll
        :ops="ops"
        :class="['start-instruction', {
          'no-scroll': mobile
        }]"
        ref="vs"
      >
        <div class="start-instruction__content">
          <p class="start-instruction__title">Приветствуем тебя, будущий студент!</p>
          <strong class="start-instruction__subtitle">Краткая инструкция к действию:</strong>
          <ul class="start-instruction__steps">
            <li>1. Подойдите к свободному специалисту и выберете до трёх направлений</li>
            <li>2. Вы увидите как загорелись выбранные вами стойки</li>
            <li>3. Подойдите к каждой из стоек и изучите интересующие вас материалы</li>
            <li>4. После этого вернитесь к специалисту и следуйте дальнейшим инструкциям</li>
          </ul>
          <p class="start-instruction__text">После прохождения основной части игры вы сможете прогуляться по приёмной комиссии и изучить каждое из направлений.</p>

          <p
            class="start-instruction__text"
            v-show="!mobile"
          >
            <strong>Управляйте персонажем с помощью клавиатуры:</strong>
          </p>
          <div
            class="start-instruction__controls"
            v-show="!mobile"
          >
            <div class="start-instruction__controls-item">
              <div class="start-instruction__key-button">W</div>
              - Вперёд
            </div>
            <div class="start-instruction__controls-item">
              <div class="start-instruction__key-button">S</div>
              - Назад
            </div>
            <div class="start-instruction__controls-item">
              <div class="start-instruction__key-button">A</div>
              - Влево
            </div>
            <div class="start-instruction__controls-item">
              <div class="start-instruction__key-button">D</div>
              - Вправо
            </div>
          </div>
          <div class="start-instruction__open-hours">
            <strong>Режим работы</strong>: 24/7 (в том числе в эпидемию и конец света)
          </div>
        </div>
      </vuescroll>
    </template>
    <template v-slot:footer>
      <button
        @click="$emit('input', false)"
        class="btn click-sound"
        type="button"
      >
        Закрыть
      </button>
    </template>
  </popup>
</template>

<script>
  import { detect } from 'detect-browser'
  import vuescroll from 'vuescroll'
  import Popup from '@/components/Popup'

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Popup,
      vuescroll
    },
    data(){
      return {
        osInfo: '',
        ops: {
          vuescroll: {
            detectResize: false
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            size: '13px',
            opacity: '.5',
            specifyBorderRadius: '0px',
            gutterOfEnds: '0px',
            gutterOfSide: '0px',
            background: '#000716'
          },
          bar: {
            size: '13px',
            opacity: '1',
            background: '#000716',
            keepShow: true
          }
        }
      }
    },
    created(){
      const deviceInfo = detect();
      this.osInfo = deviceInfo.os;
    },
    computed: {
      mobile(){
        return this.osInfo === 'Android OS' || this.osInfo === 'iOS' ? true : false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .start-instruction {
    height: 600px !important;

    &.no-scroll {
      height: auto !important;
    }
    &__content {
      display: flex;
      flex-direction: column;
      font-size: 18pt;
    }
    &__open-hours {
      font-size: 14pt;
    }
    &__title {
      font-size: 35px;
      margin: 0 0 30px;
    }
    &__subtitle {
      margin-bottom: 15px;
      font-size: 23px;
    }
    &__steps {
      margin-bottom: 30px;

      li {
        margin-bottom: 10px;
        font-size: 23px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    &__text {
      margin-bottom: 30px;
    }
    &__controls {
      display: flex;
      flex-wrap: wrap;
      width: 50%;
      margin-bottom: 30px;
    }
    &__controls-item {
      display: flex;
      width: 50%;
      margin-bottom: 15px;
      align-items: center;

      &:nth-child(n+3) {
        margin-bottom: 0;
      }
    }
    &__key-button {
      align-items: center;
      background-color: #fff;
      border: 2px inset #c4c4c4;
      border-radius: 5px;
      color: #000;
      display: flex;
      height: 48px;
      justify-content: center;
      margin-right: 5px;
      text-shadow: none;
      width: 48px;
    }
  }
</style>
